import React, { useCallback } from "react";
import { Form, Button } from "react-bootstrap";
import { FaMagnifyingGlass, FaTrashCan } from "react-icons/fa6";
import styles from "./style.module.css";

const SearchForm = ({
  prefix = "",
  digits = Array(7).fill(""),
  inputRefs,
  handlePrefixChange,
  handleDigitChange,
  handleSearch,
  setDigits,
  setPrefix,
}) => {
  const handleKeyDown = useCallback((index, e) => {
    if (e.key === "Enter") {
      if (index < 6) {
        inputRefs.current[index + 1]?.focus();
      } else {
        handleSearch();
      }
    }

    if (e.key === "Backspace") {
      e.preventDefault();

      if (digits[index] === "") {
        if (index > 0) {
          inputRefs.current[index - 1]?.focus();
        }
      } else {
        handleDigitChange(index, "");
        
        if (index > 0) {
          inputRefs.current[index - 1]?.focus();
        }
      }
    }
  }, [digits, handleDigitChange, handleSearch, inputRefs]);

  const handleClearFilters = useCallback(() => {
    setDigits(Array(7).fill(""));
    setPrefix("");
  }, [setDigits, setPrefix]);


  return (
    <div className={styles.searchContainer}>
      <div className={styles.searchInputs}>
        <Form.Select
          value={prefix}
          onChange={handlePrefixChange}
          className={styles.prefixSelect}
        >
          <option value="">Hamısı</option>
          <option value="50">050</option>
          <option value="51">051</option>
          <option value="10">010</option>
          <option value="55">055</option>
          <option value="99">099</option>
          <option value="70">070</option>
          <option value="77">077</option>
        </Form.Select>

        <div className={styles.numberInputs}>
          {digits.map((digit, index) => (
            <Form.Control
              key={index}
              placeholder="X"
              type="tel"
              value={digit}
              onChange={(e) => handleDigitChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              ref={(el) => (inputRefs.current[index] = el)}
              className={styles.numberInput}
              maxLength={1}
              inputMode="numeric"
              pattern="[0-9]*"
            />
          ))}
        </div>
      </div>

      <div className={styles.actionButtons}>
        <Button variant="primary" onClick={handleSearch} className="d-flex align-items-center justify-content-center">
          <FaMagnifyingGlass className={styles.buttonIcon} />
          Axtar
        </Button>
        <Button variant="secondary" onClick={handleClearFilters} className="d-flex align-items-center justify-content-center">
          <FaTrashCan className={styles.buttonIcon} />
          Təmizlə
        </Button>
      </div>
    </div>
  );
};

export default SearchForm;
